/*
  Footer contact buttons — the bridge to Shopify Inbox.

  Companion to section 11 of assets/wildfang.css, which retires the two floating
  launchers (Dondy WhatsApp and Shopify Inbox). WhatsApp needs nothing from this
  file: the footer renders a plain wa.me link, so that channel works with the
  Dondy widget hidden and would keep working if the app were uninstalled
  entirely. Inbox is different — it is a JS widget with no public API, so the
  only way to open it is to click the button inside its shadow root.

  <shopify-chat> exposes an OPEN shadow root and marks that button
  part="activator", so reaching it is supported rather than a hack.

  THE HONEST CAVEAT. Clicking the activator produces no observable change in
  headless Firefox — no DOM mutation, no popup, no navigation — so the panel
  could not be confirmed to open in testing. It may need a trusted event, or a
  session this environment does not have. Everything below is therefore built to
  DEGRADE GRACEFULLY rather than to assume success:

    - The footer chat button stays `hidden` until <shopify-chat> is confirmed
      present, so the store never shows a button that cannot open anything.
    - Clicking it FIRST un-hides the real Inbox launcher (by adding
      .wf-contact-show-chat to <html>), THEN forwards the click. If the
      forwarded click silently fails, the genuine launcher is now on screen at
      the bottom right for the visitor to press. The worst case is one extra
      click, never a dead end.
    - Once revealed, the launcher stays revealed for the rest of the page view.
      Someone who has asked to chat has earned the persistent affordance.

  If you later confirm the forwarded click works, nothing needs changing; the
  reveal is harmless. If you confirm it does NOT, delete the forwarding line and
  the reveal alone still gets the visitor to a working chat.
*/
(function () {
  'use strict';

  var SHOW_CLASS = 'wf-contact-show-chat';

  function activator() {
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return null;
    return host.shadowRoot.querySelector('button.activator, [part~="activator"]');
  }

  /* Section 11 hides the launcher with `html:not(.wf-contact-show-chat)`, so
     the default state needs no class and cannot flash before this file runs.
     Revealing is therefore an add, and it is deliberately not undone: someone
     who has asked to chat keeps the affordance for the rest of the page view. */
  function revealLauncher() {
    document.documentElement.classList.add(SHOW_CLASS);
  }

  /* Delegated: the footer button is in the DOM at parse time, but delegating
     costs nothing and survives a section re-render from the theme editor. */
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var trigger = event.target.closest('[data-wf-chat]');
    if (!trigger) return;

    event.preventDefault();
    revealLauncher();

    var button = activator();
    if (button) button.click();
  });

  /* Show the footer chat button only once Inbox is actually on the page. The
     widget mounts a couple of seconds after load, so poll briefly rather than
     deciding at parse time. Give up after 20s: if Inbox has not appeared by
     then it is blocked, disabled, or the visitor declined consent, and a chat
     button that opens nothing is worse than no chat button. */
  var buttons = document.querySelectorAll('[data-wf-chat]');
  if (!buttons.length) return;

  var waited = 0;
  var poll = setInterval(function () {
    waited += 500;
    if (activator()) {
      clearInterval(poll);
      for (var i = 0; i < buttons.length; i++) buttons[i].hidden = false;
    } else if (waited >= 20000) {
      clearInterval(poll);
    }
  }, 500);
})();
